export class FilterButtons {
  title = '';
  variant = '';
  filter = '';

  constructor(title: any, variant: any, filter: any) {
    this.title = title;
    this.variant = variant;
    this.filter = filter;
  }
}

export const stockFilterButtons = [
  new FilterButtons('Pending', 'info', {
    id: 'status',
    type: 'string',
    operand: 'and',
    isLike: false,
    value: 'Pending',
  }),
  new FilterButtons('Stock', 'info', { id: 'status', type: 'string', operand: 'and', isLike: false, value: 'In Stock' }),
  new FilterButtons('Errors', 'info', { id: 'status', type: 'string', operand: 'and', isLike: false, value: 'Check Request' }),
  new FilterButtons('Deployed', 'info', { id: 'status', type: 'string', operand: 'and', isLike: false, value: 'Deployed' }),
  new FilterButtons('Show All', 'info', null)
];

export const stockTotalColumns = [
  {
    Header: 'Equipment Type',
    accessor: 'type',
  },
  {
    Header: 'Amount',
    accessor: 'value'
  },
];